import React, { useState, useEffect } from 'react';
import { AdminView } from './AdminView';
import { getUserCredentials } from '../../data-sources/api';

/**
 * AdminLoginScreen component handles the admin login functionality.
 * 
 * @returns {JSX.Element} A login screen for admin users.
 */
export function AdminLoginScreen() {
    const [credentials, setCredentials] = useState([]);
    const [userAccepted, setUserAccepted] = useState(localStorage.getItem('userAuthenticated'));

    /**
         * Sets user authentication status and fetches user credentials on component mount.
         */
    useEffect(() => {
        setUserAccepted(localStorage.getItem('userAuthenticated'));
        console.log("LS värde: " + localStorage.getItem('userAuthenticated'));
        console.log(userAccepted);

        fetchUserCredentials();
    }, []);

    /**
     * Handles the form submission event for login.
     */
    const handleSubmit = (event) => {
        event.preventDefault();
        const data = new FormData(event.target);

        const inputUsername = data.get('username');
        const inputPassword = data.get('password');

        credentials.forEach((props) => {
            if (props.username === inputUsername && props.password === inputPassword) {
                setUserAccepted('true');
                localStorage.setItem('userAuthenticated', 'true');
            }
        });
        console.log(userAccepted);
    };

    /**
     * Fetches the user credentials from the API.
     */
    const fetchUserCredentials = async () => {
        try {
            const response = await getUserCredentials();
            setCredentials(response.data);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    }

    return (
        <div>
            {userAccepted === 'true' ?
                <AdminView />
                :
                <div>
                    <form onSubmit={handleSubmit} method="post" style={{ width: "400px", margin: "0 auto", paddingTop: "30px" }}>
                        <div className="form-group">
                            <label>Användarnamn</label>
                            <input name="username" type="text" className="form-control" id="username" aria-describedby="emailHelp" placeholder="Användarnamn" />
                        </div>
                        <div className="form-group">
                            <label>Lösenord</label>
                            <input name="password" type="password" className="form-control" id="password" placeholder="Lösenord" />
                        </div>
                        <button type="submit" className="btn btn-primary">Logga in</button>
                    </form>
                </div>
            }
        </div>
    );
}
